var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVipps = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 163.5 66.1"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5B24",
  d: "M0 0h163.5v66.1H0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m28 22 5.1 14.9 5-14.9H44l-8.8 22.1h-4.4L22 22z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m141.4 38.1 14.9-5.1-14.9-5v-6l22.1 8.8v4.4L141.4 44zM28 44l5.1 14.9 5-14.9H44l-8.8 22.1h-4.4L22 44zM38.1 22.1 33 7.2l-5 14.9h-6L30.9 0h4.4l8.8 22.1z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1 28 7.2 33.1l14.9 5.1v5.9L0 35.3v-4.4L22.1 22z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.3 40.6c3.7 0 5.8-1.8 7.8-4.4 1.1-1.4 2.5-1.7 3.5-.9s1.1 2.3 0 3.7c-2.9 3.8-6.6 6.1-11.3 6.1-5.1 0-9.6-2.8-12.7-7.7-.9-1.3-.7-2.7.3-3.4s2.5-.4 3.4 1c2.2 3.3 5.2 5.6 9 5.6m6.9-12.3c0 1.8-1.4 3-3 3s-3-1.2-3-3 1.4-3 3-3 3 1.3 3 3M78.3 22v3c1.5-2.1 3.8-3.6 7.2-3.6 4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V22zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8s-5.5 2.1-5.5 6.8M104.3 22v3c1.5-2.1 3.8-3.6 7.2-3.6 4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V22zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8-2.9 0-5.5 2.1-5.5 6.8M132.3 21.4c4.5 0 7.7 2.1 9.1 7.3l-4.9.8c-.1-2.6-1.7-3.5-4.1-3.5-1.8 0-3.2.8-3.2 2.1 0 1 .7 2 2.8 2.4l3.7.7c3.6.7 5.6 3.1 5.6 6.3 0 4.8-4.3 7.2-8.4 7.2-4.3 0-9.1-2.2-9.8-7.6l4.9-.8c.3 2.8 2 3.8 4.8 3.8 2.1 0 3.5-.8 3.5-2.1 0-1.2-.7-2.1-3-2.5l-3.4-.6c-3.6-.7-5.8-3.2-5.8-6.4.1-5 4.6-7.1 8.2-7.1",
  style: {
    fill: "#fff"
  }
}));
export default SvgVipps;